import blogData from './blog.json';

export const categories = blogData.categories;
export const blogPosts = blogData.posts;

export const getLatestPosts = (count = 4) => {
  return blogPosts.slice(0, count);
};

export const getPostsByCategory = (categoryId) => {
  if (categoryId === 'todos') return blogPosts;
  return blogPosts.filter(post => post.category === categoryId);
};

export const getPostBySlug = (slug) => {
  return blogPosts.find(post => post.slug === slug);
};

export const getCategoryName = (categoryId) => {
  const category = categories.find(cat => cat.id === categoryId);
  return category ? category.name : categoryId;
};
